// 證據包長期保管的純邏輯（plan SPEC #vms-web-export-archive）：大小級距、期間、延長後到期、價格對應。

export type ArchivePeriod = '90d' | '1y' | '3y';
export const ARCHIVE_PERIODS: ArchivePeriod[] = ['90d', '1y', '3y'];
export const ARCHIVE_DAYS: Record<ArchivePeriod, number> = { '90d': 90, '1y': 365, '3y': 1095 };
export type ArchiveSizeClass = '5gb' | '20gb' | '50gb';
export const ARCHIVE_SIZES: ArchiveSizeClass[] = ['5gb', '20gb', '50gb'];

const GB = 1_000_000_000; // 1 GB = 10⁹ bytes（同伺服器）
const DAY = 86_400_000;

/** 依匯出包大小選級距（≤ 5 / 20 / 50 GB）；超過 50 GB 回 null（不提供長期保管）。 */
export function archiveSizeClass(bytes: number): ArchiveSizeClass | null {
  if (bytes <= 5 * GB) return '5gb';
  if (bytes <= 20 * GB) return '20gb';
  if (bytes <= 50 * GB) return '50gb';
  return null;
}

/** 延長後的到期：接在目前到期日後面（已過就從現在起）。 */
export function archiveExpireAfter(expireAt: string | undefined, period: ArchivePeriod, nowMs: number): number {
  const cur = expireAt ? Date.parse(expireAt) : nowMs;
  return Math.max(cur, nowMs) + ARCHIVE_DAYS[period] * DAY;
}

/** 延長後超過現在起 3 年就不能買（伺服器回 ARCHIVE_TOO_LONG）。 */
export function archiveTooLong(expireAfterMs: number, nowMs: number): boolean {
  return expireAfterMs > nowMs + 1095 * DAY;
}

/** 商品的 sku：archive.<級距>.<期間>。 */
export function archiveSku(size: ArchiveSizeClass, period: ArchivePeriod): string {
  return `archive.${size}.${period}`;
}
